import {HTHGameConfig} from "../HTHGameConfig";
import {HTH} from "../HTH";
import {gsap} from "gsap";
import {Trail} from "../components/Trail";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";

export class HTHSymbolOverlay extends PIXI.Container {
    constructor() {
        super();
        this.name = "symbolOverlay";
        this.position = HTHGameConfig.reelAreaPos;
    }

    public playRemovalTrailAnim(removalSymPos: PIXI.Point, removalTargetSymPos: PIXI.Point): gsap.core.Timeline {
        const trailTl: gsap.core.Timeline = gsap.timeline(),
            trailAnim: Trail = new Trail();

        trailTl.add(this.playRemovalSymboolExplodeAnim(removalTargetSymPos));
        trailTl.add(trailAnim.play(removalTargetSymPos, removalSymPos), "<0.3");
        return trailTl;
    }


    private playRemovalSymboolExplodeAnim(pos: PIXI.Point): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const remWildAnim: TimelineSprite = this.getRemovalSymbolBlastAnim(pos);
        tl.to(remWildAnim, {alpha: 1, duration: 0.1});
        tl.add(<gsap.core.Timeline><unknown>remWildAnim.getAnimation(), "<");
        tl.add(() => {
            remWildAnim.destroy();
        });
        return tl;
    }

    private getRemovalSymbolBlastAnim(pos: PIXI.Point): TimelineSprite {
        let ts: TimelineSprite = new TimelineSprite((HTH.assetLoader.getTextures("removalSymBlastEffect")));
        ts.position.set(pos.x, pos.y);
        ts.anchor.set(0.5, 0.5);
        ts.blendMode = PIXI.BLEND_MODES.ADD;
        //  ts.pivot.set(-8, -20);
        ts.name = "RWEffect";
        ts.alpha = 0;
        // ts.hide();
        //  ts.visible = false;
        this.addChild(ts);
        return ts;
    }

}